import { Injectable, EventEmitter} from '@angular/core';

@Injectable()
export class SelectedQnrService {

  constructor() { }

  private qnr : any;
  private children :any[] = [];
  getSubForm = new EventEmitter();
  selectionType:string;

  setQnr(qnr: any, selectionType): void {
    this.qnr = qnr;
    this.selectionType = selectionType;
  }

  getQnr(): any {
    return this.qnr;
  }

  getSelectionType(){
    return this.selectionType;
  }

  setSubFormIDS(children){ //mahima
    this.children = children;
  }

  getSubFormIDS(){
    return this.children;
  }

  updatetable(id,groupId){
    this.getSubForm.emit({id:id, groupId:groupId});
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/selected-qnr.service.ts